import { useTranslation } from "@/hooks/useTranslation";
import { useDeleteSenderGroups } from "@/services";
import {
	Button,
	Card,
	CardContent,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	Icon,
	Typography,
	toast,
} from "@st-marketplace/ui";
import { useState } from "react";

export interface SenderGroupsDeleteActionProps {
	selectedIds: string[];
	onClear: () => void;
}

const SenderGroupsDeleteAction: React.FC<SenderGroupsDeleteActionProps> = ({
	selectedIds,
	onClear,
}) => {
	const { t } = useTranslation();
	const deleteGroupsMutation = useDeleteSenderGroups();

	const [confirmDeleteDialog, setConfirmDeleteDialog] =
		useState<boolean>(false);

	const handleConfirm = () => {
		deleteGroupsMutation.mutate(selectedIds, {
			onSuccess: () => {
				setConfirmDeleteDialog(false);
				toast.success(
					t("senderGroup.deleteSuccessMultiple", {
						value: selectedIds.length,
					}),
				);
				onClear();
			},
		});
	};

	if (selectedIds.length === 0) return null;

	return (
		<>
			<Card>
				<CardContent className="flex items-center justify-between">
					<Typography variant="title-sm">
						{t("senderGroup.selectedGroups", {
							value: selectedIds.length,
						})}
					</Typography>

					<Button
						type="button"
						color="secondary"
						size="sm"
						className="normal-case"
						startIcon={<Icon name="delete-bin-line" size="sm" />}
						onClick={() => setConfirmDeleteDialog(true)}
					>
						{t("senderGroup.buttonDeleteAction")}
					</Button>
				</CardContent>
			</Card>

			<Dialog open={confirmDeleteDialog} onOpenChange={setConfirmDeleteDialog}>
				<DialogContent>
					<DialogHeader>
						<DialogTitle>{t("action.areYouSure")}</DialogTitle>
						<DialogDescription>
							{t("senderGroup.confirmDelete.text", {
								value: selectedIds.length,
							})}
						</DialogDescription>
					</DialogHeader>
					<DialogFooter
						buttons={{
							secondary: {
								label: t("senderGroup.confirmDelete.cancel"),
								props: {
									type: "button",
									onClick: () => setConfirmDeleteDialog(false),
								},
							},
							primary: {
								label: t("senderGroup.confirmDelete.buttonConfirm"),
								props: {
									type: "button",
									loading: deleteGroupsMutation.isPending,
									onClick: handleConfirm,
								},
							},
						}}
					/>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default SenderGroupsDeleteAction;
